import { html, state } from 'lit-element'
import integrationTopbarStyles from './integration-topbar.styles.scss'
import { t } from '../../directives/translate'
import { ShellElement } from '../../common/shell-element'
import { SVG_SETTINGS_OUTLINED } from '@getgo/chameleon-icons'
import { unsafeSVG } from 'lit-html/directives/unsafe-svg'
import type { InternalNavigationLink } from '../navigation/types'
import { sortNavigationLinks } from '../navigation/utils'
import { getExtensionsSidebarLinks } from '../../extensions/utils'
import { getExtensionsManager } from '../../extensions/extensions-manager'

export class GoToIntegrationTopbar extends ShellElement {
  static readonly tagName = 'goto-integration-topbar'
  @state() links: readonly InternalNavigationLink[] = []

  static get styles() {
    return integrationTopbarStyles
  }

  connectedCallback() {
    super.connectedCallback()
    this.setNavLinks()
  }

  private setNavLinks() {
    this.links = sortNavigationLinks([...getExtensionsSidebarLinks(getExtensionsManager().getExtensions())])
  }

  private renderHorizontalNavRail() {
    return html` <goto-nav-bar .links=${this.links}></goto-nav-bar>`
  }

  private renderGlobalSearch() {
    return html`<li><goto-global-search class="dynamic-width"></goto-global-search></li>`
  }

  private renderCallCardListItem() {
    return html`
      <li>
        <shell-topbar-call-card-container></shell-topbar-call-card-container>
      </li>
    `
  }

  private renderUserProfileMenu() {
    return html`
      <li>
        <chameleon-icon-button size="xlarge" id="user-menu-trigger"
          ><chameleon-svg> ${unsafeSVG(SVG_SETTINGS_OUTLINED)}</chameleon-svg></chameleon-icon-button
        >
      </li>
      <chameleon-popover-v2 trigger-id="user-menu-trigger" menu position="bottom-center" label=${t('User profile menu')}
        ><goto-integration-user-menu></goto-integration-user-menu
      ></chameleon-popover-v2>
    `
  }

  render() {
    return html`
      <div class="container">
        ${this.renderHorizontalNavRail()}
        <nav aria-label=${t('GoTo topbar')}>
          <ul>
            ${this.renderGlobalSearch()}${this.renderCallCardListItem()}${this.renderUserProfileMenu()}
          </ul>
        </nav>
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    readonly [GoToIntegrationTopbar.tagName]: GoToIntegrationTopbar
  }
}
